import React, { useEffect, useState } from 'react'
import HeaderBar from '../HeaderBar/HeaderBar'
import Overview from '../Overview/Overview'
import SolutionInformation from '../SolutionInformation/SolutionInformation'
import IndustrialComputingpage from '../SolutionInformation/Industrialcomputingpage'
import Cybersecuritypage from '../SolutionInformation/Cybersecuritypage'
import Pneumaticspage from '../SolutionInformation/Pneumaticspage'
import Networkingpage from '../SolutionInformation/Networkingpage'
import MotionControlpage from '../SolutionInformation/MotionControlspage'
import OperatorInterfacepage from '../SolutionInformation/OperatorInterfacepage'
import PowerMonitoringpage from '../SolutionInformation/PowerMonitoringpage'
import Drivespage from '../SolutionInformation/Drivespage'
import IIotSolutionspage from '../SolutionInformation/IIotSolutionspage'
import Sensorspage from '../SolutionInformation/Sensorspage'
import MachineSafetypage from '../SolutionInformation/MachineSafetypage'
import ControlPanelSolutionspage from '../SolutionInformation/ControlPanelSolutionspage'
import { Link } from '@material-ui/core'
import content from '../content.json'
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom'

import './App.scss'

/**
 * The App component is the main component in which all other components are loaded.
 * App is also responsible for all the react-routing going on in this application at the head level
 */
 function App(props) {
    return (
        <div className="App">
            <Router>
                {/* <HeaderBar /> */}
                <div className="body-wrapper">
                    <Switch>
                   
                        <Route exact path="/">
                            <Redirect to="/ia-graphic" />
                        </Route>

                        <Route exact path="/ia-graphic">
                            <Overview />
                        </Route>

                        <Route path="/ia-graphic/solution/IndustrialComputing">
                            <IndustrialComputingpage />
                        </Route>

                        <Route  path="/ia-graphic/solution/Cybersecurity">
                            <Cybersecuritypage />
                        </Route>

                        <Route path="/ia-graphic/solution/Pneumatics">
                            <Pneumaticspage />
                        </Route>

                        <Route  path="/ia-graphic/solution/Networking">
                            <Networkingpage />
                        </Route>

                        <Route  path="/ia-graphic/solution/MotionControls">
                            <MotionControlpage />
                        </Route>

                        <Route  path="/ia-graphic/solution/OperatorInterface">
                            <OperatorInterfacepage />
                        </Route>

                        <Route  path="/ia-graphic/solution/PowerMonitoring">
                            <PowerMonitoringpage />
                        </Route>

                        <Route  path="/ia-graphic/solution/Drives">
                            < Drivespage/>
                        </Route>

                        <Route  path="/ia-graphic/solution/IIotSolutions">
                            < IIotSolutionspage/>
                        </Route>

                        <Route  path="/ia-graphic/solution/Sensors">
                            < Sensorspage/>
                        </Route>

                        <Route  path="/ia-graphic/solution/MachineSafety">
                            < MachineSafetypage/>
                        </Route>

                        <Route  path="/ia-graphic/solution/ControlPanelSolutions">
                            < ControlPanelSolutionspage/>
                        </Route>



                        </Switch>

                    
                </div>
            </Router>
        </div>
    )
}

export default App